import { Box, SizableText, YStack } from '@my/ui'

export interface ReportGroupFormData {
  reason: string
}

export interface ReportGroupPostFormProps {
  onSubmit: (data: ReportGroupFormData) => void
}

const reasons = [
  'Dangerous or illegal',
  'Discriminatory',
  'Misinformation',
  'Disrespectful',
  'Other',
]

export const ReportGroupPostForm = (props: ReportGroupPostFormProps) => {
  return (
    <YStack gap="$3">
      {reasons.map((reason) => (
        <Box key={reason} onPress={() => props.onSubmit({ reason })} pressable>
          <SizableText size="$5" fow="500" color="$gray12">
            {reason}
          </SizableText>
        </Box>
      ))}
    </YStack>
  )
}
